export const FLEX_SHARES = Object.freeze({ low: 0.25, medium: 0.5, high: 0.75 })
export const FULLY_DEPRECIATED_RESIDUAL = 1 // EUR

export const CALC_DEFAULTS = Object.freeze({
    annualRefinancingRate: 0.095,
    breakEven: 0.85,
})

const RULES = Object.freeze({
    annualRefinancingRate: { min: 0, max: 1 },                    
    breakEven:             { min: 0, max: 1, minExclusive: true }, 
})

function readSanitized(value, rule) {
    const n = typeof value === 'string' && value.trim() !== '' ? Number(value) : value
    if (typeof n !== 'number' || !Number.isFinite(n)) return null
    if (rule.minExclusive ? n <= rule.min : n < rule.min) return null
    if (rule.maxExclusive ? n >= rule.max : n > rule.max) return null
    return n
}

export function getCalcParams() {
    const raw = (typeof window !== 'undefined' && window.calcParams
        && typeof window.calcParams === 'object' ? window.calcParams : {}) || {}
    const out = {}
    for (const key of Object.keys(CALC_DEFAULTS)) {
        const candidate = readSanitized(raw[key], RULES[key])
        out[key] = candidate == null ? CALC_DEFAULTS[key] : candidate
    }
    return out
}
